<div class="input-group mb-3 has-validation" [ngClass]="{'d-none': props.hidden}">
    <div class="form-floating" [class.is-invalid]="showError">
        <input type="input" class="form-control"
            [class.is-invalid]="showError" 
            [formControl]="formControl" 
            [formlyAttributes]="field"
            ngbDatepicker #datepickerInput="ngbDatepicker"
            [attr.aria-describedby]="id + '-formly-validation-error'"
            [attr.aria-invalid]="showError" />
        <label [for]="field.id" class="form-label" >{{props.label}}<span *ngIf="props.required">*</span></label>
    </div>
    <span class="input-group-text" (click)="datepickerInput.toggle()"><i class=" bi bi-calendar3"></i></span>
    <div *ngIf="showError" class="invalid-feedback" style="display: block;">
        <formly-validation-message [field]="field"></formly-validation-message>
    </div>
</div>